import React, { forwardRef, useState } from 'react';
import { FieldProps, InjectedFieldProps } from 'react-admin';

import MenuItem from '@material-ui/core/MenuItem';

import EditLevelDialog from './EditLevelDialog';
import { RewardLevelDto } from '../../types';

type EditLevelActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardLevelDto;
};

const EditLevelActionField = forwardRef<HTMLLIElement, EditLevelActionFieldProps>(
  ({ record }, ref) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <>
        <MenuItem ref={ref} onClick={handleOpen}>
          Edit
        </MenuItem>

        {open && <EditLevelDialog open={open} onClose={handleClose} level={record} />}
      </>
    );
  }
);

export default EditLevelActionField;
